import type {
  BillingInterval,
  StoreProductData,
} from '@legacy/common-ui-models';

import type { ScStoreProductData } from '../models/product.model';

/* eslint-disable complexity */
export const mapScStoreProduct = (
  product: ScStoreProductData
): StoreProductData => {
  const {
    SuiteCrmId,
    Price,
    CampaignId,
    IsSubscription,
    SubscriptionInterval,
  } = product.fields;
  const {
    Title,
    SubTitle,
    LongTitle,
    LongSubtitle,
    Image,
    Text,
    Highlight,
    Scores = [],
    Usps = [],
    ProductInfo = [],
    SubmitButtonText,
    SubmitButtonAction,
    SubmitButtonLink,
    SecondaryButtonText,
    SecondaryButtonStyle,
    SecondaryButtonAction,
    SecondaryButtonLink,
    ProductPricePrefixLabel,
    ProductPriceSuffixLabel,
  } = product.fields.Content.fields;

  return {
    suiteCrmId: SuiteCrmId?.value ?? '',
    price: Price?.value,
    campaignId: CampaignId?.value,
    isSubscription: IsSubscription?.value,
    subscriptionInterval: SubscriptionInterval?.fields?.value
      ?.value as BillingInterval,
    content: {
      title: Title?.value ?? '',
      subTitle: SubTitle?.value ?? '',
      longTitle: LongTitle?.value ?? '',
      longSubtitle: { value: LongSubtitle?.value ?? '' },
      image: Image?.value ?? {},
      text: Text?.value ?? '',
      highlight: Highlight?.value ?? '',
      scores: Scores.map(({ fields: { Text: text, OutOf5 } }) => ({
        text: text?.value ?? '',
        outOf5: parseInt(OutOf5?.value ?? '0'),
      })),
      usps: Usps.map(({ fields: { Text: text, Inactive, Tooltip } }) => ({
        text: text?.value ?? '',
        inactive: Inactive?.value ?? false,
        tooltip: Tooltip?.value ?? '',
      })),
      submitButtonText: SubmitButtonText?.value ?? '',
      productInfo: ProductInfo.map(({ fields: { Icon, Key, Value } }) => ({
        icon: Icon,
        key: Key?.value,
        value: Value?.value,
      })),
      submitButtonAction: SubmitButtonAction?.fields.value?.value,
      submitButtonLink: SubmitButtonLink?.value,
      secondaryButtonText: SecondaryButtonText?.value ?? '',
      secondaryButtonStyle: SecondaryButtonStyle?.fields.value?.value,
      secondaryButtonAction: SecondaryButtonAction?.fields.value?.value,
      secondaryButtonLink: SecondaryButtonLink?.value,
      productPricePrefixLabel: ProductPricePrefixLabel?.value,
      productPriceSuffixLabel: ProductPriceSuffixLabel?.value,
    },
  };
};
